import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Modal, Form, Row, Col, Select, Button} from 'antd'
import {withTranslation} from 'react-i18next'

@inject('mappingManagementStore')
@observer
class FormModal extends Component {
  state = {}
  formRef = React.createRef()

  componentDidMount() {
    const {mappingManagementStore, title} = this.props
    const {addKeyList} = mappingManagementStore
    if (title === 'edit') {
      this.formRef.current.setFieldsValue({
        field: Array.from(addKeyList)
      })
    }
  }

  handleOk = () => {
    const {mappingManagementStore, handleCancelKey} = this.props
    this.formRef.current.validateFields().then(fieldsValue => {
      mappingManagementStore.onChangeAddKey(fieldsValue.field);
      handleCancelKey()
    })
  }
  handleCancel = () => {
    const {handleCancelKey} = this.props
    handleCancelKey()
  }

  render() {
    const {mappingManagementStore, addKeyModalVisible, handleCancelKey, t} = this.props
    const {outboundList} = mappingManagementStore
    return (
      <>
        <Modal
          title={`${t(`mappingManagement.addition`)} ${t(`mappingManagement.jointPrimaryKey`)}`}
          closable={true}
          visible={addKeyModalVisible}
          // onOk={this.handleOk}
          onCancel={handleCancelKey}
          maskClosable={false}
          destroyOnClose={true}
          bodyStyle={{minHeight: 200}}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={this.handleOk}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={handleCancelKey}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <Form ref={this.formRef} key="addKey" initialValues={{}} layout="vertical">
            <Row justify="start" gutter={[10, 10]}>
              <Col xs={24} sm={24} md={24} span={24}>
                <Form.Item name="field" label={t(`mappingManagement.field`)}
                           rules={[{required: false, message: `${t(`general.pleaseSelect`)} ${t(`mappingManagement.field`)}`}]}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear mode="multiple" showArrow maxTagCount="responsive" maxTagTextLength={30}>
                    {outboundList.map(item => <Select.Option key={item.path} value={item.path}>{item.path}</Select.Option>)}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
